import React from 'react';

import * as S from './styles';
import { DataFormProps } from 'components/FormDynamicPageSelected/Forms/InputsSingleBanner';

interface DefaultProps {
	bannerData: DataFormProps;
}

export default function Default({ bannerData }: DefaultProps) {
	return (
		<S.container>
			<S.img
				src={bannerData.banner.image.relativePath}
				alt={bannerData.title}
			/>
		</S.container>
	);
}
